import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../../core/redux/action";
import { ChevronUp, Info } from "react-feather";
import { all_routes } from "../../../Router/all_routes";
import DatePickup from "../../components/DatePickup/DatePickup";
import { useEffect } from "react";
import apiHandler from "../../common/api";
import { Country, State, City } from "country-state-city";
import moment from "moment";
import Select from "react-select";
import { Imageurl, NoImage } from "../../../config";
import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";
import { isValidAustralianPhoneNumber } from "../../common/common";
import Swal from "sweetalert2";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";
import withReactContent from "sweetalert2-react-content";

function CustomerMaster() {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const userData = useSelector((state) => state.user_data);
  const navigate = useNavigate();
  const routes = all_routes;
  const allCountries = Country.getAllCountries();
  const customerId = useParams()?.id || 0;
  const [loading, setLoading] = useState(false);
 const MySwal = withReactContent(Swal);
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");

  console.log(customerId, "customerId");
  const [options, setOptions] = useState({
    gender: [],
    countries: allCountries.map((c) => ({
      value: c.name,
      label: c.name,
    })),
  });

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formData, setFormData] = useState({
    id: 0,
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    birthDate: "",
    gender: 0,
    country: "",
    state: "",
    city: "",
    address: "",
    zipCode: "",
    businessId: userData?.businessId,
    profile: "",
    prevProfile: "",
    dirname: pathname[1],
    phoneNumberError: "",
    firstNameError: "",
    lastNameError: "",
    emailError: "",
  });

  useEffect(() => {
    if (customerId > 0) {
      const getCustomerDetails = async () => {
        const response = await apiHandler({
          method: "GET",
          route: `Business/customerbyid?customerId=${customerId}`,
        });
        if (response.ResponseCode === "SUCCESS") {
          setFormData(response.ResponseData[0]);
        }
      };
      getCustomerDetails();
    }
  }, []);

  useEffect(() => {
    if (formData.country) {
      const statesData = State.getStatesOfCountry(
        allCountries.find((c) => c.name === formData.country)?.isoCode
      );
      setOptions((prev) => ({
        ...prev,
        states: statesData.map((s) => ({
          value: s.name,
          label: s.name,
        })),
      }));

      // If editing with a pre-filled state, fetch cities right away
      if (formData.state) {
        const cities = City.getCitiesOfState(
          allCountries.find((c) => c.name === formData.country)?.isoCode,
          statesData.find((s) => s.name === formData.state)?.isoCode
        );

        setOptions((prev) => ({
          ...prev,
          cities: cities.map((c) => ({
            value: c.name,
            label: c.name,
          })),
        }));
      }
    }
  }, [formData.country, formData.state]);

  console.log(formData, "formData");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const formatDBPhoneNumber = (number) => {
    if (!number) return "";

    // Ensure it starts with +61
    let cleaned = number.replace(/\D/g, ""); // remove non-digits
    if (cleaned.startsWith("61")) {
      cleaned = "+" + cleaned;
    } else if (cleaned.startsWith("0")) {
      cleaned = "+61" + cleaned.substring(1);
    } else if (!cleaned.startsWith("+61")) {
      cleaned = "+61" + cleaned;
    }

    // Remove + for formatting spaces, but keep for final output
    const noPlus = cleaned.replace("+", "");

    // Format: +61 4 1234 5678
    return "+" + noPlus.replace(/^61(\d)(\d{4})(\d{4})$/, "61 $1 $2 $3");
  };

  const isValidAustralianPhoneNumbercust = (number) => {
    const digits = number.replace(/\D/g, ""); // remove non-digits
    const mobilePattern = /^61[4]\d{8}$/; // Mobile
    const landlinePattern = /^61[2378]\d{8}$/; // Landline
    const testPattern = /^61[5]\d{8}$/; // If you also want 5xx (test case you gave)

    return (
      mobilePattern.test(digits) ||
      landlinePattern.test(digits) ||
      testPattern.test(digits)
    );
  };

const handleSubmit = async (e) => {
  setLoading(true);
  e.preventDefault();

  // Reset error messages before starting validation
  setFormData((prevState) => ({
    ...prevState,
    firstNameError: "",
    lastNameError: "",
  }));

  // Validate first name and last name
  let hasError = false;

  if (!formData.firstName.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      firstNameError: "First Name is required.",
    }));
    hasError = true;
  }

  if (!formData.lastName.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      lastNameError: "Last Name is required.",
    }));
    hasError = true;
  }

  if (!formData.phoneNumber.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      phoneNumberError: "Phone Number is required.",
    }));
    hasError = true;
  }

  if (!formData.email.trim()) {
    setFormData((prevState) => ({
      ...prevState,
      emailError: "Email is required.",
    }));
    hasError = true;
  }

  if (hasError) {
    setLoading(false);
    return; // Stop the form submission if there's an error
  }

  // Validate phone number
  if (formData.phoneNumber && !isValidAustralianPhoneNumber(formData.phoneNumber)) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please enter a valid Australian mobile number (e.g., 614XXXXXXXX).",
    });
    setLoading(false);
    return;
  }

  // Proceed with the API call if all validations pass
  const response = await apiHandler({
    method: "POST",
    route: `Business/customerUpsert`,
    payload: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (response.ResponseCode === "SUCCESS") {
          MySwal.fire({
            // title: "Upsert!",
            // text: "Your file has been Upsert.",
            title: customerId > 0 ? "Customer Updated!" : "Customer Added!",
            text: customerId > 0 ? "The Customer details have been successfully updated." : "The Customer has been successfully added.",
            className: "btn btn-success",
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn btn-success",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(routes.customerList);
            }
          });
  } else {
    console.log(response, "data");
  }
  setLoading(false);
};

  const handleCancle = () => {
    navigate(routes.customerList);
  };

  useEffect(() => {
    getGenderAll();
  }, []);

  const getGenderAll = async () => {
    const subResponse = await apiHandler({
      method: "GET",
      route: `Superadmin/genderAll`,
    });

    if (subResponse.ResponseCode === "SUCCESS") {
      const optionmanage = subResponse.ResponseData?.map((u) => ({
        value: u.ID,
        label: u.Name,
      }));
      setOptions((prev) => ({
        ...prev,
        gender: optionmanage,
      }));
    }
  };

  console.log(options, "optionsList");

  const Handlefile = (e) => {
    let file = e.target.files[0];

    if (!file) return;

    const fileUrl = URL.createObjectURL(file);

    setFormData({
      ...formData,
      profile: imgpathgenerator(file.name, pathname[1]) || "",
      dirname: `${pathname[1]}`,
      uniquefileName:
        JSON.stringify([imgpathgenerator(file.name, pathname[1])]) || "[]",
      prevProfile: fileUrl,
      files: file,
    });
  };

  const handleCancel = () => {
    setFormData({
      ...formData,
      prevProfile: "",
    });
  };

  return (
    <>
     <LoadingSpinner isLoading={loading} />
      <div>
      {" "}
      <div className="mt-5">
        <div className="page-wrapper  pt-0">
          <div className="content">
            <div className="page-header">
              <div className="add-item d-flex">
                <div className="page-title">
                  <h4>Customer</h4>
                  <h6>Manage Customer</h6>
                </div>
              </div>

              <ul className="table-top-head">
                <li>
                  <OverlayTrigger
                    placement="top"
                    overlay={renderCollapseTooltip}
                  >
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      id="collapse-header"
                      className={data ? "active" : ""}
                      onClick={() => {
                        dispatch(setToogleHeader(!data));
                      }}
                    >
                      <ChevronUp />
                    </Link>
                  </OverlayTrigger>
                </li>
              </ul>
            </div>

            <div className="">
              <div className="">
                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item show">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingOne"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Customer Information
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingOne"
                    >
                      <div className="accordion-body">
                        <div className="row">
                          <div className="container my-3">
                            <div className="card custome-card-padding rounded-2 mb-0">
                              <div className="row align-items-center">
                                {/* Image Preview */}
                                <div className="col-auto">
                                  <input
                                    type="file"
                                    name="profile"
                                    className="d-none"
                                    ref={(input) =>
                                      (window.customerProfileInput = input)
                                    }
                                    onChange={Handlefile}
                                  />
                                  <img
                                    src={
                                      formData?.prevProfile
                                        ? formData.prevProfile
                                        : formData?.profile
                                        ? Imageurl + formData.profile
                                        : NoImage
                                    }
                                    alt="Customer"
                                    className="custome-image rounded-circle"
                                    width="80"
                                    height="80"
                                    style={{
                                      objectFit: "cover",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (window.customerProfileInput) {
                                        window.customerProfileInput.click();
                                      }
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src =
                                        "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png";
                                    }}
                                  />
                                </div>

                                {/* Label and Info */}
                                <div className="col-auto">
                                  <h6 className="mb-0 fw-bold">
                                    Upload Customer Image
                                  </h6>
                                  <small className="text-color-70">
                                    Image should be below 500 kb
                                  </small>
                                </div>

                                {/* Cancel Button */}
                                <div className="col-auto d-flex gap-3 ms-auto">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={handleCancel}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="w-100 col-12">
                          <div className="row mb-2">
                            <div className="form-group col-xl-6 col-md-6 col-12 ">
                              <label className="text-sm-medium">
                                First Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="firstName"
                                placeholder="First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                              />
                                    {formData.firstNameError && (
        <div className="text-danger">{formData.firstNameError}</div>
      )}
                            </div>
                            <div className="form-group col-xl-6 col-md-6 col-12">
                              <label className="text-sm-medium">
                                Last Name
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="lastName"
                                placeholder="Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                              />
                              {formData.lastNameError && (
        <div className="text-danger">{formData.lastNameError}</div>
      )}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="form-group col-xl-6 col-md-6 col-12">
                              <label className="text-sm-medium">
                                Mobile Number
                              </label>
                              <input
                                type="text" // must be text to allow + and spaces
                                name="phoneNumber"
                                className="form-control"
                                placeholder="Add Number After +61"
                                value={
                                  formatDBPhoneNumber(formData.phoneNumber) ||
                                  ""
                                }
                                onChange={(e) => {
                                  let raw = e.target.value.replace(/\D/g, ""); // keep only digits

                                  // Replace leading 0 with 61
                                  if (raw.startsWith("0"))
                                    raw = "61" + raw.slice(1);

                                  // Ensure prefix 61
                                  if (!raw.startsWith("61")) raw = "61" + raw;

                                  // Max 11 digits
                                  raw = raw.slice(0, 11);

                                  // Update form state (raw number only, no spaces)
                                  setFormData((prev) => ({
                                    ...prev,
                                    phoneNumber: "+" + raw,
                                  }));
                                }}
                                // readOnly={isDisable}
                                onBlur={() => {
                                  if (
                                    formData.phoneNumber &&
                                    !isValidAustralianPhoneNumbercust(
                                      formData.phoneNumber
                                    )
                                  ) {
                                    setFormData((prev) => ({
                                      ...prev,
                                      phoneNumberError:
                                        "Please enter a valid Australian Phone Number (e.g., +61 4XX XXX XXX or +61 2 XXXX XXXX).",
                                    }));
                                  } else {
                                    setFormData((prev) => ({
                                      ...prev,
                                      phoneNumberError: "",
                                    }));
                                  }
                                }}
                              />
                              {formData.phoneNumberError && (
                                <span className="text-danger">
                                  {formData.phoneNumberError}
                                </span>
                              )}
                            </div>
                            <div className="form-group col-xl-6 col-md-6 col-12">
                              <label className="text-sm-medium">Email</label>
                              <input
                                className="form-control"
                                type="email"
                                name="email"
                                placeholder="Enter Your Email"
                                value={formData.email}
                                onChange={handleChange}
                              />
                              {formData.emailError && (
                               <div className="text-danger">{formData.emailError}</div>
                              )}
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="form-group col-xl-6 col-md-6 col-12">
                              <label className="text-sm-medium">
                                Date of Birth
                              </label>

                              <DatePickup
                                filterDate={formData?.birthDate}
                                //   showDefaultDate={true}
                                handleDateChange={(e) =>
                                  handleChange({
                                    target: {
                                      value: moment(e).format("YYYY-MM-DD"),
                                      name: "birthDate",
                                    },
                                  })
                                }
                              />
                            </div>
                            <div className="form-group col-xl-6 col-md-6 col-12">
                              <label className="text-sm-medium">Gender</label>
                              <Select
                                classNamePrefix="react-select"
                                placeholder="Select Gender"
                                options={options?.gender}
                                value={options?.gender?.find(
                                  (el) => el.value == formData?.gender
                                )}
                                onChange={(e) =>
                                  handleChange({
                                    target: { name: "gender", value: e.value },
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item show">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingTwo"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseOne"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne"
                      >
                        <div className="card-title-head">
                          <h6 className="m-0 p-0" style={{ border: "none" }}>
                            <span>
                              <Info className="feather-edit" />
                            </span>
                            Address Information
                          </h6>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="panelsStayOpen-headingTwo"
                    >
                      <div className="accordion-body">
                        <div className="w-100 col-12">
                          {/* Address Field */}
                          <div className="row mb-2">
                            <div className="form-group col-12">
                              <label className="text-sm-medium">Address</label>
                              <input
                                className="form-control"
                                type="text"
                                name="address"
                                placeholder="Address"
                                value={formData.address}
                                onChange={handleChange}
                              />
                            </div>
                          </div>

                          {/* City, State, Country Row */}

                          <div className="row mb-2">
                            <div className="form-group col-xl-4 col-md-6 col-12">
                              <label className="text-sm-medium">Country</label>
                              <Select
                                classNamePrefix="react-select"
                                placeholder="Select Country"
                                options={options?.countries}
                                value={options?.countries?.find(
                                  (el) => el.value == formData?.country
                                )}
                                onChange={(e) =>
                                  handleChange({
                                    target: { name: "country", value: e.value },
                                  })
                                }
                              />
                            </div>

                            <div className="form-group col-xl-4 col-md-6 col-12">
                              <label className="text-sm-medium">State</label>
                              <Select
                                classNamePrefix="react-select"
                                placeholder="Select Gender"
                                options={options?.states}
                                value={options?.states?.find(
                                  (el) => el.value == formData?.state
                                )}
                                onChange={(e) =>
                                  handleChange({
                                    target: { name: "state", value: e.value },
                                  })
                                }
                              />
                            </div>

                            <div className="form-group col-xl-4 col-md-6 col-12">
                              <label className="text-sm-medium">City</label>
                              <Select
                                classNamePrefix="react-select"
                                placeholder="Select Gender"
                                options={options?.cities}
                                value={options?.cities?.find(
                                  (el) => el.value == formData?.city
                                )}
                                onChange={(e) =>
                                  handleChange({
                                    target: { name: "city", value: e.value },
                                  })
                                }
                              />
                            </div>

                            {/* Postcode Field */}
                            {/* <div className="row mb-2"> */}
                            <div className="form-group col-xl-4 col-md-6 col-12">
                              <label className="text-sm-medium">Postcode</label>
                              <input
                                className="form-control"
                                type="text"
                                name="zipCode"
                                placeholder="Postcode"
                                value={formData.zipCode}
                                onChange={handleChange}
                              />
                            </div>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Add Action Buttons */}
                <div className="col-lg-12 col-md-12 col-12 mt-4">
                  <div className="btn-addproduct mb-4">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-md me-2"
                      onClick={handleCancle}
                    >
                      Cancel
                    </button>

                    <button
                      className="btn btn-primary btn-md me-2"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
   
  );
}

export default CustomerMaster;
